import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityAddUser } from '../../projectDetailsActivities.models';

export const AddUserActivity = ({ values }: IProjectActivity<IProjectActivityAddUser>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_AddUser_01')}
      <b>{values.email}</b>
      {t('activity_description_AddUser_02')}
      <b>{values.role}</b>.
    </span>
  );
};
